module.exports = __webpack_public_path__ + "static/ebr-16-b6fc19e78ca5814aaf75e4211f6fbcbd.jpg";